import React, { useCallback, useEffect, useRef, useState } from 'react'
import Card from './Card'
import Order_section from './Order_section'
import axios from 'axios';
import { BallTriangle } from 'react-loader-spinner';
import Loading from '../Screens/Loading';

const ProductShow = ({products,nextPage,nextPath,titles}) => {
  const [load,setLoad]=useState(false);
  const [loadFilter,setLoadFilter]=useState(false);
  const [allProducts,setAllProduct]=useState([]);
  const [nextLink,setNextLink]=useState('');
  const [path,setPath]=useState('');
  const containerRef = useRef(null);
 const load_next_page=()=>{
  setLoad(true);
  axios.get(nextLink)
  .then(function (response) {
    if(response.data.success){
      console.log(response.data.data);

      setAllProduct([...allProducts,...response.data.data.data]);
  
      if(response.data.data.next_page_url){
        setNextLink(response.data.data.next_page_url)
      }else{
        setNextLink('')
      }
    }
    setLoad(false);
      })
  .catch(function (error) {
    console.log('error');
    setLoad(false);
  });
 }
 const handleClick=(filter)=>{
   console.log(filter);
   if(filter){
    setLoadFilter(true);
    axios.get(`${path}/${filter}`)
    .then(function (response) {
      if(response.data.success){
        console.log(response.data.data);
        setAllProduct(response.data.data.data);
        setNextLink(response.data.data.next_page_url);  
      }
      setLoadFilter(false);
        })
    .catch(function (error) {
      console.log('error');
      setLoadFilter(false);
    });
   }
 }
 const observer = useRef()
 const lastBookElementRef = useCallback(node => {
   if (load) return
   if (observer.current) observer.current.disconnect()
   observer.current = new IntersectionObserver(entries => {
     if (entries[0].isIntersecting && nextLink) {
      load_next_page();
     }
   })
   if (node) observer.current.observe(node)
 }, [nextLink])
 useEffect(() => {
  setAllProduct(products);
  if(nextPage)
  setNextLink(nextPage);  
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}, [products]);
useEffect(() => {
  if(nextPath) 
 setPath(nextPath);
}, []);
  if(products.length===0)
     return (<div style={{ textAlign:'center',color:'red',fontSize:'20px',height:'200px' }}>لا يوجد منتجات</div>)

  return (
<div className='mt-5 container'>  
{nextPath?(
  <Order_section titles={titles} handleClick={handleClick} />
):(
  <div className='container'>
      <p style={{ fontSize:'18px', color:'gray',borderRight:'3px solid goldenrod',paddingRight:'10px',marginBottom:'20px'}}>{titles[0].name}</p>
  </div>
)}
{loadFilter?(
  <Loading/>
):(
<div className='d-flex justify-content-center  flex-wrap gap-3 mb-3'>
{allProducts.map((product)=>(
    <div key={product.id} className='products'>
   <Card product={product}/>
    </div>
))
}
<div className='d-flex justify-content-center mt-1 mb-4' ref={lastBookElementRef}>
    {nextLink&&(
         load?(
        <BallTriangle 
          height={60}
          width={60}
          radius={4}
          color="goldenrod"
          ariaLabel="ball-triangle-loading"
          wrapperClass={{}}
          wrapperStyle=""
          visible={true}
/>

         ):
          (
          <button   className='login-button sign-button' onClick={load_next_page}  style={{ fontSize:'12px' }}>تحميل المذيد</button>
        )
    )}
    </div>
    </div>
)}

   
   

    

</div>
  )
}

export default ProductShow